// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"ProductListPagination_paginationWrapper__L6TMJ","paginationText":"ProductListPagination_paginationText__pHB_F"};